import React from 'react';
import styles from './ToastNotifications.module.css';
import { useNotifications } from '../contexts/NotificationContext';

const variantToIcon = {
  success: '✓',
  info: 'ℹ',
  warning: '⚠',
  error: '⨯'
} as const;

const ToastNotifications = () => {
  const { notifications, remove } = useNotifications();

  return (
    <div className={styles.container}>
      {notifications.map(n => (
        <div
          key={n.id}
          className={`${styles.toast} ${styles[n.variant]}`}
          role="status"
          aria-live="polite"
        >
          <div className={styles.icon}>{variantToIcon[n.variant]}</div>
          <div className={styles.message}>{n.message}</div>
          <button className={styles.close} onClick={() => remove(n.id)} aria-label="Dismiss notification">
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastNotifications;




